
import CreativeTag from '../../demand/creative-tag/index.vue';

export default {
  components: {
    CreativeTag: CreativeTag
  }
};